<ion-item button (click)="onFileClick()" detail="false">
  <ion-label>
    <h3>
      <div class="flex flex-row justify-between">
        <div>
          {{ fileName() }}
        </div>
      </div>
    </h3>
    <div>
      <div class="flex flex-row justify-between items-center">
        <p class="text-gray-500 text-xs">
          {{ fileDate() | date : "dd.MM.yyyy" }}
        </p>
      </div>
    </div>
  </ion-label>
  <ion-button (click)="openMenu($event)" slot="end" fill="clear">
    <ion-icon slot="icon-only" mode="ios" color="dark" name="ellipsis-vertical"></ion-icon>
  </ion-button>
</ion-item>